import { createSlice } from '@reduxjs/toolkit';
import { apiHolder } from 'api';
const storageApi = apiHolder.api.getDataStoreApi();
const FOLD_STORAGE_KEY = 'MenuFold';
const PINNED_MENU_EXPAND = 'PinnedMenuExpand';
const MENU_EDIT_SETTING_HIDDEN_KEY = 'menu_edit_setting_tooltip_hidden';
const expandMenuSlice = createSlice({
    name: 'expandMenuSlice',
    initialState: () => {
        return {
            isFold: storageApi.getSync(FOLD_STORAGE_KEY).data === '1',
            isPinnedMenuExpand: storageApi.getSync(PINNED_MENU_EXPAND).data !== '0',
            isSettingTooltipHidden: storageApi.getSync(MENU_EDIT_SETTING_HIDDEN_KEY).data === 'true',
        };
    },
    reducers: {
        setIsFold: (state, action) => {
            state.isFold = action.payload;
            storageApi.put(FOLD_STORAGE_KEY, action.payload ? '1' : '0', {
                noneUserRelated: false,
            });
        },
        setSettingTooltipHidden: state => {
            state.isSettingTooltipHidden = true;
            storageApi.put(MENU_EDIT_SETTING_HIDDEN_KEY, 'true', {
                noneUserRelated: false,
            });
        },
        setIsPinnedMenuExpand: (state, action) => {
            state.isPinnedMenuExpand = action.payload;
            storageApi.put(PINNED_MENU_EXPAND, action.payload ? '1' : '0', {
                noneUserRelated: false,
            });
        },
    },
});
export const { actions } = expandMenuSlice;
export default expandMenuSlice.reducer;
